<template>
	<div>
		<Wrapper
			:id="roomObj.id + 'room' + roomObj.roomIndex"
			class="blinkers"
			:class="[this.$style.blinkers, {
        'is-active-throb': isActive,
      }]"
			@click="handleRoomButtonClick"
			v-touch:tap="handleRoomButtonClick"
			:top="top"
			:left="left"
			:completed="completed"
		>
			<div
				:class="$style['unanswered-room-button-container']"
				v-if="status === 'unanswered' || status === 'answeredCorrect' || status === 'answeredIncorrect'"
			>
				<!-- <div :class="$style.debugDiv">
					room: {{ roomObj.roomIndex }}<br>
					question: {{ questionIndex }}
					{{ title }}
        </div>-->
				<div
					class="room-button unanswered unanswered-outer-circle"
					:class="[$style['unanswered-outer-circle'], {
            'is-active-outer-circle': isActive
          }]"
				></div>
				<div
					class="unanswered-inner-circle"
					:class="[$style['unanswered-inner-circle'], {
          'is-active-inner-circle': isActive
        }]"
				></div>
				<div
					data-name="room-button-hover-el"
					:class="$style['room-button-hover-el']"
				></div>
			</div>
			<!-- <div
				class="room-button answered-correct"
				:class="$style['answered-correct']"
				v-if="status === 'answeredCorrect'"
			>
				<svg
					version="1.1"
					:class="$style.checkMarkSvg"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					viewBox="0 0 10.6 7.8"
					style="enable-background:new 0 0 10.6 7.8;"
					xml:space="preserve"
					aria-hidden="true"
					aria-label="check mark svg"
					title="check mark svg"
				>
					<path
						class="st0"
						d="M8.3,0.7L4,4.7L2.4,3.1c-0.5-0.4-1.2-0.4-1.7,0c-0.5,0.4-0.5,1.1,0,1.6L3.2,7c0.5,0.4,1.2,0.4,1.7,0L10,2.3
            c0.5-0.4,0.5-1.1,0-1.6C9.5,0.3,8.7,0.3,8.3,0.7z"
					/>
				</svg>
      </div>-->
			<div
				class="room-button answered-incorrect"
				:class="$style['answered-incorrect']"
				v-if="status === 'answeredIncorrect'"
			>
				<svg
					version="1.1"
					:class="$style.xMarkSvg"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					viewBox="0 0 8.3 8.4"
					style="enable-background:new 0 0 8.3 8.4;"
					xml:space="preserve"
					aria-hidden="true"
					aria-label="x mark svg"
					title="x mark svg"
				>
					<path
						class="st0"
						d="M7.7,6.3L5.6,4.2l2.1-2.1c0.4-0.4,0.4-1,0-1.4l0,0c-0.4-0.4-1-0.4-1.4,0L4.2,2.8L2.1,0.7c-0.4-0.4-1-0.4-1.4,0
              l0,0c-0.4,0.4-0.4,1,0,1.4l2.1,2.1L0.7,6.3c-0.4,0.4-0.4,1,0,1.4l0,0c0.4,0.4,1,0.4,1.4,0l2.1-2.1l2.1,2.1c0.4,0.4,1,0.4,1.4,0l0,0
              C8.1,7.3,8.1,6.7,7.7,6.3z"
					/>
				</svg>
			</div>
		</Wrapper>
	</div>
</template>

<script>
/*
  possible states for room-button:
    -'unanswered'
    -'answeredCorrect'
    -'answeredIncorrect'
*/
import styled from "vue-styled-components";
import { TweenMax, TimelineMax, Power2 } from "gsap";

const WrapperProps = {
	top: Number,
	left: Number
};

const Wrapper = styled("div", WrapperProps)`
	position: absolute;

	// top: ${props => props.top}px;
	// left: ${props => props.left}px;
	transform: translate(-50%, -50%);

	border-radius: 50%;
	// border: 1px solid rgba(255,255,255,0.5);

	color: white;

	font-family: sans-serif;
	font-weight: bold;

	cursor: pointer;

	z-index: 100;
`;

export default {
	name: "room-button",
	components: {
		Wrapper
	},
	props: {
		buttonText: String,
		roomObj: Object,
		top: Number,
		left: Number,
		status: String,
		isActive: Boolean,
		tl: Object,
		questionIndex: Number,
		title: String
	},
	data() {
		return {
			TestString: "",
			clicked: false,
			buttonEl: null
		};
	},
	computed: {
		completed: function() {
			return this.$store.getters.getQuestionByIds(
				this.roomObj.roomIndex,
				this.roomObj.id
			).completed;
		}
	},
	mounted() {
		this.$bus.$on("room-button-pos-change", this.handlePosChange);

		// :id="roomObj.id + 'room' + roomObj.roomIndex"
		this.buttonId = this.roomObj.id + "room" + this.roomObj.roomIndex;
		this.buttonEl = document.getElementById(this.buttonId);

		TweenMax.set(this.buttonEl, {
			top: this.top,
			left: this.left,
			ease: Power2.easeOut
		});
	},
	methods: {
		handleRoomButtonClick: function(e) {
			this.$emit("obj-clicked", e, this.roomObj);
		},
		handlePosChange(d) {
			let { top, left } = d;

			TweenMax.to(this.buttonEl, 0.5, {
				top,
				left
			});
		}
	}
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.text {
	pointer-events: none;
}

// .text-container {
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   color: white;

//   z-index: 4000;
// }

.cardWrapper {
	position: absolute;
	left: 0px;
	width: 100vw;
}

.unanswered-room-button-container {
	position: relative;

	width: 40px;
	height: 40px;

	// outline: 1px solid red;
}

.unanswered-outer-circle {
	position: absolute;
	top: 0;
	left: 0;

	width: 40px;
	height: 40px;

	border-radius: 50%;

	background-color: rgba(255, 255, 255, 0.3);

	cursor: pointer;

	pointer-events: none;

	transition: all 0.3s ease-out;
}

.unanswered-inner-circle {
	position: absolute;
	top: 12px;
	left: 12px;

	width: 40%;
	height: 40%;

	border-radius: 50%;

	background-color: $sun;

	pointer-events: none;
}

.answered-correct {
	display: flex;
	justify-content: center;
	align-items: center;

	width: 40px;
	height: 40px;

	background-color: $white;
	color: $sun;

	border-radius: 50%;

	cursor: pointer;

	transition: all 0.3s ease-out;
}

.answered-incorrect {
	display: flex;
	justify-content: center;
	align-items: center;

	width: 40px;
	height: 40px;

	background-color: $white;
	color: $sun;

	border-radius: 50%;

	cursor: pointer;

	transition: all 0.3s ease-out;
}

.answered-incorrect:hover,
.answered-correct:hover {
	transform: scale(1.3);

	transition: all 0.1s ease-out;
}

.blinkers {
	// transition: left 0.25s ease-out, top 0.25s ease-out;
	// opacity: 0;
}

.checkMarkSvg {
	height: 40%;

	pointer-events: none;

	& path {
		fill: #369c46;
	}
}

.xMarkSvg {
	height: 40%;

	pointer-events: none;

	& path {
		fill: #e32f26;
	}
}

.room-button-hover-el {
	position: absolute;
	top: 43%;
	left: 43%;

	height: 6px;
	width: 6px;

	border-radius: 50%;

	background-color: #f7923b;

	transition: all 0.3s ease-out;

	transform-origin: center center;

	pointer-events: none;
}

.blinkers:hover .room-button-hover-el {
	transform: scale(3);

	transition: all 0.1s ease-out;
}

// .blinkers:hover .unanswered-outer-circle {
//   transform: scale(3);

//   transition: all 0.1s ease-out;
// }

.debug-div {
	background-color: black;

	width: 180px;

	pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/RoomButton.vue